import { render, staticRenderFns } from "./CreateFuel.vue?vue&type=template&id=4453eba0"
import script from "./CreateFuel.vue?vue&type=script&lang=js"
export * from "./CreateFuel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports